export default {"src":"/_next/static/media/non-alcohalic.aeee2a02.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};